import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import navIcon1 from '../assets/img/nav-icon1.svg';
import navIcon2 from '../assets/img/nav-icon2.svg';
import navIcon3 from '../assets/img/nav-icon3.svg';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import "../App.css";
import siteConfig from "../config/site.config";
import { MusicNoteBeamed } from 'react-bootstrap-icons';
import playerService from './Player/Service/playerService';

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState('home');
  const [scrolled, setScrolled] = useState(false);
  const [autoPlay, setAutoPlay] = useState(false);

  useEffect(() => {
    if (autoPlay) {
      playerService.play();
    } else {
      playerService.pause();
    }
  }, [autoPlay]);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, [])

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  }

  const handleSocialClick = (platform) => {
    toast.info(`${platform} profile link will be available soon...`, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        color: '#fff'
      }
    });
  }

  const handleToggleAutoPlay = () => {
    setAutoPlay((prev) => {
      const next = !prev;
      toast(next ? 'Auto play music enabled!' : 'Auto play music disabled!', {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        style: {
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          color: '#fff'
        }
      });
      return next;
    });
  };

  return (
    <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
      <Container>
        <Navbar.Brand as={Link} to="/">
          <span className="logo-text">{siteConfig.siteName}</span>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="navbar-toggler-icon"></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {siteConfig.navLinks.map((link, index) => (
              <HashLink
                key={index}
                to={`/${link.path}`}
                className={activeLink === link.name.toLowerCase() ? 'active navbar-link nav-link' : 'navbar-link nav-link'}
                onClick={() => onUpdateActiveLink(link.name.toLowerCase())}
                smooth
              >
                {link.name}
              </HashLink>
            ))}
          </Nav>
          <span className="navbar-text" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div className="social-icon">
              <a onClick={() => handleSocialClick('LinkedIn')} href={siteConfig.socialLinks.linkedin}><img src={navIcon1} alt="LinkedIn" /></a>
              <a onClick={() => handleSocialClick('Facebook')} href={siteConfig.socialLinks.facebook}><img src={navIcon2} alt="Twitter" /></a>
              <a onClick={() => handleSocialClick('Instagram')} href={siteConfig.socialLinks.instagram}><img src={navIcon3} alt="GitHub" /></a>
            </div>
            <button
              style={{
                background: 'transparent',
                border: 'none',
                outline: 'none',
                cursor: 'pointer',
                marginRight: '8px',
                display: 'flex',
                alignItems: 'center',
                color: autoPlay ? '#AA367C' : '#888',
                fontSize: '1.6rem',
                transition: 'color 0.2s'
              }}
              onClick={handleToggleAutoPlay}
              title={autoPlay ? 'Pause' : 'Play'}
            >
              <MusicNoteBeamed />
            </button>
            <HashLink to="/#connect" smooth>
              <button className="vvd"><span>Let's Connect</span></button>
            </HashLink>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}
